export const getIsLocal = () => /^local/.test(document.location.hostname);
export const redirectTo = url => {
  window.location.href = url;
};